import { Navigate } from "react-router-dom";
import { useIsAuthenticated } from "../../contexts/UserProvider";

export function PrivateRoute({children, ...rest}){

    const isAuthed = useIsAuthenticated();
    return isAuthed?children:<Navigate to="/login"/>
}